import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Tables from "layouts/tables";
import { useState } from "react";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { useSelector } from "react-redux";
import { hasActionAccess } from "utility";
import AddForm from "./addForm";
import { useGetTestimonialsQuery } from "slices/cms/testimonialSlice";
import { useAddTestimonialMutation } from "slices/cms/testimonialSlice";
import { useUpdateTestimonialMutation } from "slices/cms/testimonialSlice";
import { useDeleteTestimonialMutation } from "slices/cms/testimonialSlice";

function Testimonials() {
  const naviagte = useNavigate();
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [add] = useAddTestimonialMutation();
  const [update] = useUpdateTestimonialMutation();
  const [del] = useDeleteTestimonialMutation();
  const auth = useSelector((state) => state.auth.auth?.user);

  const { data, isLoading, refetch } = useGetTestimonialsQuery({
    page,
    limit,
    search,
  });

  const col = [
    { display: "Name", key: "name", type: "display" },
    {
      display: "Thumbnail",
      key: "thumbnail",
      type: "image",
      style: { width: "100px", height: "100px", borderRadius: "20%" },
    },

    { display: "Video Link", key: "url", type: "display" },
    { display: "Description", key: "decription", type: "display" },
  ];

  const canEdit = hasActionAccess(auth, "Beauty App", "Services", "edit");
  const canDelete = hasActionAccess(auth, "Beauty App", "Services", "delete");
  if (canEdit || canDelete) {
    col.push({
      display: "Actions",
      key: "edit",
      type: "action",
      render: (row, onEdit, handleDelete) => (
        <>
          {canEdit && <Button onClick={() => onEdit(row)}>Edit</Button>}
          {canDelete && (
            <Button onClick={() => handleDelete(row._id)}>Delete</Button>
          )}
        </>
      ),
    });
  }

  const handleSearchChange = (value) => {
    setSearch(value);
    setPage(1);
  };

  const changePage = (newPage, newLimit) => {
    const apiPage = newPage + 1; // MUI is 0-based, API is 1-based
    setPage(apiPage);
    setLimit(newLimit);
  };

  const onEdit = (row) => {
    setEditing(row);
    setOpen(true);
  };

  const handleAdd = () => {
    setEditing(null);
    setOpen(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this testimonial?")) {
      await del(id).unwrap();
      refetch();
    }
  };

  const handleSubmit = async (data) => {
    try {
      if (editing) {
        await update({ id: data._id, body: data }).unwrap();
      } else {
        const { _id, ...rest } = data; // 🚀 remove _id before adding
        await add(rest).unwrap();
      }
      refetch();
      setOpen(false);
    } catch (e) {
      console.log("e===========>", e);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setEditing(null); // <-- Clear editing data
  };

  const canAdd = hasActionAccess(auth, "Beauty App", "Services", "add");

  return (
    <DashboardLayout>
      <DashboardNavbar />

      {canAdd && (
        <Button onClick={handleAdd} style={{ background: "#fff" }}>
          Add+
        </Button>
      )}

      <AddForm
        open={open}
        onClose={handleClose}
        initialData={editing}
        onSubmit={handleSubmit}
      />

      <Tables
        title={"Testimonials"}
        handleSearch={handleSearchChange}
        totalPages={data?.pagination?.totalPages}
        data={data?.data}
        columns={col}
        changePage={changePage}
        onEdit={onEdit}
        handleDelete={handleDelete}
        currentPage={page} // ✅ pass to control current pagination
        rowsPerPage={limit}
      />
      <Footer />
    </DashboardLayout>
  );
}

export default Testimonials;
